const Fn = {
  validaRut: function (rut) {
    // Eliminar puntos y guión
    rut = rut.replace(/\./g, "").replace("-", "");

    // Separar el cuerpo del dígito verificador
    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1).toUpperCase();

    // Validar largo mínimo del cuerpo
    if (cuerpo.length < 7) {
      return false;
    }

    // Calcular dígito verificador
    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += multiplo * parseInt(cuerpo.charAt(i), 10);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperado = 11 - (suma % 11);
    const dvCalculado =
      dvEsperado === 11 ? "0" : dvEsperado === 10 ? "K" : dvEsperado.toString();

    // Comparar dígito verificador calculado con el ingresado
    return dvCalculado === dv;
  },
  formatRut: function (rut) {
    rut = rut.replace(/\./g, "").replace(/-/g, "").toUpperCase(); // limpiamos
    if (rut.length === 0) return "";

    let cuerpo = rut.slice(0, -1);
    let dv = rut.slice(-1);

    // Insertar puntos cada tres dígitos desde el final del cuerpo
    cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `${cuerpo}-${dv}`;
  },
};
export { Fn };
